export const SET_FOOTER = "setFooter";
